import styled from 'styled-components';

const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    margin-bottom: 14px;
`;

export default ButtonContainer;
